const isJson = item => {
  let it = typeof item !== "string" ? JSON.stringify(item) : item;

  try {
    it = JSON.parse(it);
  } catch (e) {
    return false;
  }

  if (typeof it === "object" && it !== null) {
    return true;
  }

  return false;
};

const camelCase = str => {
  const st = str
    .replace(/-/g, " ") // convert all hyphens to spaces
    .replace(/\s[a-z]/g, str.toLowerCase()) // convert first char of each word to UPPERCASE
    .replace(/\s+/g, "") // remove spaces
    .replace(/^[A-Z]/g, str.toUpperCase()); // convert first char to lowercase
  return st;
};

export { isJson, camelCase };



// WEBPACK FOOTER //
// ./src/util/utilities.js